import {useScopeQuery} from "@/core/store/scopeQuery";
import {defineStore, storeToRefs} from "pinia";
import {computed, ref} from "vue";

import saleClientCardApplyByPhoneQuery from "@/gql/gen/query/saleClientCardApplyByPhoneQuery";
import {useGraphql} from "@/core/graphql/service";
import saleClientCardFetchQuery from "@/gql/gen/query/saleClientCardFetchQuery";
import {BonusLevel, SaleClientCard} from "@/gql/gen";
import {useVorderState} from "@/modules/shop/store/vorder-state";

const STORE_NAME = "shop-loyalty";

export const useLoalityStore = defineStore(STORE_NAME, () => {
    const {registerScopeQuery} = useScopeQuery();

    const vorderState = useVorderState()

    const {bonuses} = storeToRefs(vorderState)

    const clientCard = ref<SaleClientCard | null>();
    const bonusLevels = ref<BonusLevel[]>([]);

    const bonusLevel = computed(() => {
        return clientCard.value?.LEVEL
    })

    const bonusesAvailable = computed(() => {
        return clientCard.value?.BONUSES || 0
    })

    const getBonusesMax = (oderPrice: number) => {
        let maxPercent = clientCard.value?.BONUSES_PERCENT || 100;
        const max = Math.round(maxPercent * (oderPrice / 100));
        return bonusesAvailable.value < max ? bonusesAvailable.value : max;
    }

    const {useLazyQuery} = useGraphql();

    // SCOPE QUERY
    registerScopeQuery(
        STORE_NAME,
        "app",
        {
            sale_bonus_level_list: {
                __fragment: "BonusLevelFields",
            },
        },
        (data) => {
            if (data.sale_bonus_level_list)
                bonusLevels.value = data.sale_bonus_level_list;
        }
    );

    registerScopeQuery(
        STORE_NAME,
        "user",
        {
            sale_client_card_fetch: {
                __fragment: "ClientCardFields",
            },
        },
        (data) => {
            if (data.sale_client_card_fetch) {
                clientCard.value = data.sale_client_card_fetch;
            }
        }
    );

    const clientCardApplyByPhoneQuery = useLazyQuery(
        saleClientCardApplyByPhoneQuery({
            __fragment: "ClientCardFields",
        }),
        {
            debounced: 1000,
        }
    );

    clientCardApplyByPhoneQuery.onResult((card) => {
        if (card) {
            clientCard.value = card;
        }
    });

    const clientCardRequest = useLazyQuery(saleClientCardFetchQuery({
        __fragment: 'ClientCardFields'
    }), {
        initialResult: () => clientCard.value,
        onResult: (result) => clientCard.value = result,
        cache: 1000,
    })

    return {
        bonuses,
        bonusesAvailable,
        getBonusesMax,
        clientCardRequest,
        clientCard,
        clientCardApplyByPhoneQuery,
        bonusLevels,
        bonusLevel
    };
});

